(function () {
    'use strict';
    var controllerId = 'schedaCompetenzeAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'common', 'schedaCompetenze', schedaCompetenzeAddFn]);

    function schedaCompetenzeAddFn($scope, $uibModalInstance, datacontext, common, schedaCompetenze) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');

        $scope.schedaCompetenze = schedaCompetenze;
        if ($scope.schedaCompetenze.Id == 0) {   // sono nel nuovo
            $scope.Titolo = 'Nuova Scheda Didattica per Competenze';
        }

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = {};
                if ($scope.schedaCompetenze.Id == 0) { // sono nel nuovo
                   
                    addItem($scope.schedaCompetenze).then(function (result) {
                        if (result.Id && result.Id > 0)
                            $uibModalInstance.close(result);
                    });
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Aggiunta elemento
        function addItem(item) {
            return datacontext.schedaCompetenze_add(item).then(function (data) {

                if (!data || data.Id == null || data.Id == 0) {
                    logError("Errore durante la creazione del dato");            // In questo caso l'aggiunta non � andata a buon fine
                    return null;
                }

                return data;                                                     // altrimenti torna il nuovo oggetto
            });
        }
    }
    
})();